import {
  ACCOUNT_QUERY_KEYS,
  useFetchAccountBFFQuery,
} from "queries/account.queries";
import { useEffect } from "react";
import { useAppSelector } from "./useAppSelector";
import { useQueryClient } from "@tanstack/react-query";
import { AccountDetails } from "features/types";

export const useAccount = () => {
  const { data, isFetching, refetch, ...rest } = useFetchAccountBFFQuery();
  const storedUserId = useAppSelector((state) => state.auth.id);
  const queryClient = useQueryClient();

  const updateFetchAccountBffCache = (account: AccountDetails) => {
    queryClient.setQueriesData([ACCOUNT_QUERY_KEYS.fetchAccountBff], {
      ...data,
      account,
    });
  };

  useEffect(() => {
    if (storedUserId !== undefined && data === undefined) {
      refetch();
    }
  }, [storedUserId]);

  return {
    accountWithEvents: data,
    account: data?.account,
    accountEvents: data?.events,
    redemptionLimits: data?.redemptionLimits,
    isFetching,
    fetchAccount: refetch,
    updateFetchAccountBffCache,
    ...rest,
  };
};
